module.exports = __webpack_public_path__ + "media/src/images/loadingSpinner--dark-567279c7eeef51454793facc64701a67.png";